import { GenericResponse } from 'src/app/data/repository/generic-response';
import { SupportService } from './../../../data/repository/support-repository/support.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-message',
  templateUrl: './message.component.html',
  styles: [
    `
      textarea {
        color: rgb(0, 0, 0);
        font-family: Vazir;
        font-size: 16px;
        position: relative;
        top: 16px;
        right: 0;
        width: calc(100% - 32px);
        padding: 16px;
        text-align: right;
        line-height: 24px;
        border: none;
        resize: none;
        background: rgb(249, 249, 249);
        border-top: 1px solid rgb(200, 199, 204);
        border-bottom: 1px solid rgb(200, 199, 204);
      }

      textarea:focus {
        outline: none;
      }
    `,
  ],
})
export class MessageComponent implements OnInit {
  constructor(private supportService: SupportService) {}
  message = '';
  isIOS = false;

  ngOnInit() {
    setTimeout(() => {
      if (!this.isIOS) {
        document.getElementById('textarea').focus();
      }
      this.autoGrow();
    }, 100);
  }
  autoGrow() {
    document.getElementById('textarea').style.height = '5px';
    document.getElementById('textarea').style.height =
      document.getElementById('textarea').scrollHeight - 32 + 'px';
    // document.getElementById('bioHolder').style.height = (document.getElementById('textarea').scrollHeight + 9).toString() + 'px';
  }
  save(faqId: string | null): Promise<GenericResponse> {
    // console.log('saved', this.gender);
    // return this.userApiService.editUser(null, this.gender, null, null, null);
    return this.supportService.sendMessage(this.message, faqId);
  }

  isIos = () => {
    const userAgent = window.navigator.userAgent.toLowerCase();
    return /iphone|ipad|ipod/.test(userAgent);
  };
}
